var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D27F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.045 15.1137L21.303 16.9998H27.5003V11.4999C27.5003 10.6731 26.8273 10 26.0004 10H14.0004C13.1736 10 12.5005 10.6731 12.5005 11.4999V14H17.9649C18.8029 14 19.58 14.4162 20.045 15.1137Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 24.999H18.0002C18.2767 24.999 18.4998 25.2756 18.4998 25.4987V25.9983C18.4998 26.2748 18.2758 26.498 18.0002 26.498H14.0001C13.7236 26.498 13.5005 26.2214 13.5005 25.9983V25.4987C13.5005 25.2221 13.7245 24.999 14.0001 24.999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4993 17.9998H21.0346C20.8668 17.9998 20.7112 17.9164 20.6184 17.7776L19.2122 15.6684C18.9329 15.2503 18.467 15 17.9645 15H12.5001C11.1221 15 10 16.1212 10 17.5001V27.4997C10 28.8777 11.1212 29.9998 12.5001 29.9998H27.499C28.877 29.9998 29.9992 28.8787 29.9992 27.4997V20.4999C29.9992 19.1219 28.878 17.9998 27.499 17.9998L27.4993 17.9998ZM19.5002 25.9989C19.5002 26.8257 18.8271 27.4988 18.0003 27.4988H14.0003C13.1735 27.4988 12.5004 26.8257 12.5004 25.9989V25.4992C12.5004 24.6724 13.1735 23.9994 14.0003 23.9994H18.0003C18.8271 23.9994 19.5002 24.6724 19.5002 25.4992V25.9989Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetIcon);
export default __webpack_public_path__ + "static/media/asset-icon.dc6beae3.svg";
export { ForwardRef as ReactComponent };